import React, { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import { AdminIcon } from './AdminIcon';

let openModals = 0;
let originalOverflow = '';
let rootWasInert = false;

export const Modal: React.FC<{ title: string; subtitle?: string; onClose: () => void; busy?: boolean; children: React.ReactNode; footer?: React.ReactNode }> = ({ title, subtitle, onClose, busy = false, children, footer }) => {
  const id = useId();
  const ref = useRef<HTMLDivElement>(null);
  const closeRef = useRef(onClose);
  const busyRef = useRef(busy);
  closeRef.current = onClose; busyRef.current = busy;
  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null;
    const root = document.getElementById('root');
    if (openModals === 0) { originalOverflow = document.body.style.overflow; rootWasInert = Boolean(root?.hasAttribute('inert')); }
    openModals += 1;
    root?.setAttribute('inert', '');
    document.body.style.overflow = 'hidden';
    ref.current?.focus();
    const keydown = (event: KeyboardEvent) => {
      if (document.querySelectorAll('[data-app-modal]')[document.querySelectorAll('[data-app-modal]').length - 1] !== ref.current) return;
      if (event.key === 'Escape') { event.preventDefault(); if (!busyRef.current) closeRef.current(); }
      if (event.key === 'Tab') {
        const elements = Array.from(ref.current?.querySelectorAll<HTMLElement>('button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), a[href], [tabindex="0"]') || []).filter(el => el.getClientRects().length > 0);
        const first = elements[0], last = elements[elements.length - 1];
        if (!first) { event.preventDefault(); ref.current?.focus(); }
        else if (event.shiftKey && (document.activeElement === first || document.activeElement === ref.current)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || document.activeElement === ref.current)) { event.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', keydown);
    return () => {
      document.removeEventListener('keydown', keydown);
      openModals -= 1;
      if (openModals === 0) { document.body.style.overflow = originalOverflow; if (!rootWasInert) root?.removeAttribute('inert'); }
      if (previous?.isConnected) previous.focus();
    };
  }, []);
  return createPortal(<div className="app-modal-backdrop" onMouseDown={event => { if (event.target === event.currentTarget && !busy) onClose(); }}>
    <div ref={ref} data-app-modal role="dialog" aria-modal="true" aria-labelledby={id} aria-busy={busy} tabIndex={-1} className="app-modal">
      <header className="app-modal-header"><div><span className="app-modal-eyebrow">Gisela Serra · Psicanálise</span><h3 id={id}>{title}</h3>{subtitle && <p>{subtitle}</p>}</div><button type="button" className="list-icon-button" aria-label="Fechar" title="Fechar" disabled={busy} onClick={onClose}><AdminIcon name="close" /></button></header>
      <div className="app-modal-body">{children}</div>
      {footer && <footer className="app-modal-footer">{footer}</footer>}
    </div>
  </div>, document.body);
};
